import { useTranslation } from 'next-i18next'
import { css } from 'styled-components'

import { breakpoints, colors } from '@/styles'

import { ColorCard, Description, Text } from './elements'

const smallText = css`
  margin: 8px 0;
  line-height: 33px;
  max-width: 270px;

  @media (max-width: ${breakpoints.phoneMax}) {
    margin: 0;
    font-size: 17px;
    line-height: 24px;
  }
`

const smallDesc = css`
  margin: auto 0;
  max-width: 390px;

  @media (max-width: ${breakpoints.card}) {
    margin: auto;
  }

  @media (max-width: ${breakpoints.phoneMax}) {
    margin: auto 0;
    font-size: 27.5px;
    line-height: 32px;
    letter-spacing: -0.03px;
    max-width: 230px;
  }
`

const PlatformForRenters = ({ breakpoint }: { breakpoint: string }) => {
  const { t } = useTranslation('renters')
  return (
    <ColorCard color={colors.secondary}>
      <Text color={colors.white} customStyle={smallText}>
        {t('renters:Built by renters, for renters')}
      </Text>
      <Description
        alwaysLarge
        color={colors.white}
        breakpoint={breakpoint}
        customStyle={smallDesc}
      >
        {t('renters:A smarter way to rent, at your fingertips.')}
      </Description>
    </ColorCard>
  )
}

export default PlatformForRenters
